export default __webpack_public_path__ + "static/media/arras15.805769fc.jpg";